import { FC, ReactNode } from "react";
import styles from "./CardWrapper.module.scss";

interface ICardWrapperProps {
    children: ReactNode;
}

export const CardWrapper: FC<ICardWrapperProps> = ({ children }) => (
    <div className={styles.cardWrapper}>
        {children}
    </div>
);